import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  center: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
  },
  loader: {
    border: "16px solid #f3f3f3" /* Light grey */,
    borderTop: "16px solid #172953" /* Blue */,
    borderRadius: "50%",
    width: "120px",
    height: "120px",
    animation: "$spin 2s linear infinite",
  },
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
});

function Loader() {
  const classes = useStyles();

  return (
    <div className={classes.center}>
      <div className={classes.loader}></div>
    </div>
  );
}

export default Loader;
